import {create} from 'zustand';

export interface CampaignPageStore {
  campaignPreview?: React.ReactNode;
  menu?: React.ReactNode;
  setCampaignPreview: (campaignPreview: React.ReactNode) => void;
  setMenu: (menu: React.ReactNode) => void;
}

export const useCampaignPageStore = create<CampaignPageStore>(set => ({
  campaignPreview: undefined,
  menu: undefined,
  setCampaignPreview: campaignPreview => set({campaignPreview}),
  setMenu: menu => set({menu}),
}));
